var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { memo, useRef, useState, useEffect } from "react";
import "@frameworks/salesjourney/stylesheets/components/Generic/TransparentHeader/TransparentHeader.scss";
import GenericPopup from "@frameworks/shared-library/components/GenericPopup";
import _ from "underscore";
import { Form } from "react-bootstrap";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import ClientSearch from "@frameworks/salesjourney/components/Generic/ClientSearch";
import clientDi from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useNavigate } from "react-router-dom";
import "@frameworks/salesjourney/stylesheets/components/Header/HeaderPopups.scss";
import { useSelector } from "react-redux";
import NotificationPopup from "@frameworks/salesjourney/components/Header/HeaderPopups/NotificationPopup";
import leadDi from "@frameworks/salesjourney/components/Features/LeadDashboard/di/serviceLocator";
import homeDI from "@frameworks/salesjourney/components/Home/di/index";
import { checkIfMFIsAccessible, debounce, } from "@frameworks/salesjourney/utils/genericMethods";
import ProfilePopup from "@frameworks/salesjourney/components/Header/HeaderPopups/ProfilePopup";
import profileDI from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import { getImageString } from "@frameworks/salesjourney/utils/genericMethods";
import { ECurrentLoginComponent } from "@domains/salesFeatures/Login/entities/iLogin";
import { ERole } from "@frameworks/salesjourney/components/Login/Login";
import LoginCommonInputButton from "@frameworks/salesjourney/components/Login/common/LoginCommonInputButton";
import OTPValidation from "@frameworks/salesjourney/components/Login/LoginPages/OTPValidation";
import ResetPassword from "@frameworks/salesjourney/components/Login/LoginPages/ResetPassword";
import ChangePasswordSuccess from "@frameworks/salesjourney/components/Login/LoginPages/ChangePasswordSuccess";
import EdModal from "@frameworks/shared-library/components/edModal";
import SetOffDesk from "@frameworks/salesjourney/components/Header/HeaderPopups/SetOffDesk";
import TextFirstAlphabetAsIcon from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/TextFirstAlphabetAsIcon";
import { EdButtonIcon } from "@frameworks/web/components/generic/edbutton/edButton";
var HeaderLeftSideComponent = memo(function (props) {
    return React.createElement(React.Fragment, null, props === null || props === void 0 ? void 0 : props.children);
}, isLeftSideComponentSame);
function isLeftSideComponentSame(prev, next) {
    return _.isEqual(prev, next);
}
export var EModalChild;
(function (EModalChild) {
    EModalChild["CURRENT_PASSWORD"] = "CURRENT_PASSWORD";
    EModalChild["OTP_VALIDATION"] = "OTP_VALIDATION";
    EModalChild["RESET_PASSWORD"] = "RESET_PASSWORD";
    EModalChild["SUCCESS_MESSAGE"] = "SUCCESS_MESSAGE";
})(EModalChild || (EModalChild = {}));
var iconTextColorForProfileIcon = {
    textColor: "txt_dark-purple",
    backgroundColor: "bg_blush-pink",
};
var TransparentHeader = function (props) {
    var _a;
    var _b = __read(useState(false), 2), showProfilePopup = _b[0], setShowProfilePopup = _b[1];
    var _c = __read(useState(false), 2), isSearchFocused = _c[0], setIsSearchFocused = _c[1];
    var searchRef = useRef(null);
    var _d = __read(useState(false), 2), searchPopup = _d[0], setSearchPopup = _d[1];
    var _e = __read(useState(""), 2), searchText = _e[0], setSearchText = _e[1];
    var _f = __read(useState(false), 2), loader = _f[0], setLoader = _f[1];
    var searchInputRef = useRef(null);
    var _g = __read(useState([]), 2), clientSearchDataState = _g[0], setClientSearchDataState = _g[1];
    var _h = __read(useState(false), 2), notifyPopup = _h[0], setNotifyPopup = _h[1];
    var _j = __read(useState(0), 2), totolNotificationCount = _j[0], setTotalNotificationCount = _j[1];
    var _k = __read(useState(0), 2), pipelineAgingLeadCount = _k[0], setPipelineAgingLeadCount = _k[1];
    var _l = __read(useState(false), 2), notificationLoader = _l[0], setNotificationLoader = _l[1];
    var _m = __read(useState(), 2), criticalPriorityAging = _m[0], setCriticalPriorityAgingData = _m[1];
    var _o = __read(useState([]), 2), folloupAgeingData = _o[0], setFolloupAgeingData = _o[1];
    var _p = __read(useState(0), 2), notificationCountExceptExpiry = _p[0], setNotificationCountExceptExpiry = _p[1];
    var _q = __read(useState(false), 2), passwordChangeSuccess = _q[0], setPasswordChangeSuccess = _q[1];
    var _r = __read(useState(""), 2), currentPassword = _r[0], setCurrentPassword = _r[1];
    var _s = __read(useState(0), 2), criticalLeadsCount = _s[0], setCriticalLeadsCount = _s[1];
    var _t = __read(useState(), 2), file = _t[0], setFile = _t[1];
    var _u = __read(useState(true), 2), desk = _u[0], setDesk = _u[1];
    var _v = __read(useState(false), 2), changePasswordPopup = _v[0], setChangePasswordPopup = _v[1];
    var _w = __read(useState(EModalChild.CURRENT_PASSWORD), 2), modalChild = _w[0], setModalChild = _w[1];
    var _x = __read(useState(false), 2), showLoader = _x[0], setShowLoader = _x[1];
    var _y = __read(useState(), 2), maskedUserData = _y[0], setMaskedUserData = _y[1];
    var _z = __read(useState({
        isShowError: false,
        errorMessage: "",
    }), 2), error = _z[0], setError = _z[1];
    var _0 = __read(useState(), 2), resendOTPDuration = _0[0], setResendOTPDuration = _0[1];
    var _1 = __read(useState(false), 2), showDeskPeriodPopup = _1[0], setShowDeskPeriodPopup = _1[1];
    var _2 = __read(React.useState(null), 2), remappingCount = _2[0], setRemappingCount = _2[1];
    var _3 = __read(useState(false), 2), isMFAccessible = _3[0], setIsMFAccessible = _3[1];
    var _4 = __read(useState(false), 2), showBookmarksRippleEffect = _4[0], setShowBookmarksRippleEffect = _4[1];
    var previousBookmarksCountRef = useRef(null);
    var navigate = useNavigate();
    var ClientSearchData = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.data; });
    var expiringLeads = useSelector(function (state) { return state.SalesHome.expiringLeads.reducersData; });
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    var profileImage = useSelector(function (state) { return state.Profile.ProfileDetails.reducersData.profileImage; });
    var onDesk = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.onDeskDetails;
    });
    var bookmarksCount = useSelector(function (state) { return state.Bookmarks.bookmarksCountReducer.bookmarksCount; });
    // functions related to search
    var handleOnchangeSearch = function (e) {
        var inputValue = e.target.value;
        setSearchText(inputValue);
        if (inputValue.length < 3) {
            setClientSearchDataState([]);
            return;
        }
        setLoader(true);
        setSearchPopup(true);
        setSearchText(inputValue);
        debounce(function () { return getClientSearchData(inputValue); });
    };
    var callBackFunctionClientSearch = function (data) {
        setSearchPopup(false);
        if (data === null || data === void 0 ? void 0 : data.isPartner) {
            var searchActionPayload = {
                AcCode: data.accountCode,
                page: 1,
                pageSize: 100,
            };
            clientDi.partnerOverview.initSummaryLoader();
            localStorage.setItem("client360SelectedClient", JSON.stringify(data));
            clientDi.clients.clearSelectedClientData();
            clientDi.partnerOverview.getPartnerSearchAction(searchActionPayload, data);
        }
        else {
            clientDi.partnerOverview.clearALLStoreData();
            clientDi.clients.setSelectedClientOnSearchClick(data);
        }
        navigate("/clientdetails/overview?link=".concat(data.isPartner ? "profile" : "overview"));
    };
    var getClientSearchData = function (searchText) {
        clientDi.clients.getClientSearchData({ searchText: searchText });
    };
    // functions relaed to notifications
    var getExpiringLeads = function () {
        var req = {
            page: "1",
            pageSize: "100",
        };
        homeDI.home.getExpiringLeads(req);
    };
    var getAllNotifications = function () {
        setNotificationLoader(true);
        var getFollowUpAgingRMs = leadDi.leads
            .getFollowUpAgingRMs({ page: 1, pageSize: 100 })
            .then(function (resp) { var _a; return (_a = resp.data) !== null && _a !== void 0 ? _a : []; })
            .catch(function (error) { return []; });
        var getCriticalPriorityAging = leadDi.leads
            .getCriticalPriorityAging()
            .catch(function (error) { return ({ totalItems: 0 }); });
        var getRemappingNotificationList = leadDi.leads
            .getRemappingClientTaskCount()
            .catch(function (error) { return ({ data: 0 }); });
        var getPipelineAgingLeadCount = leadDi.leads
            .getPipelineAgingLeadCount()
            .then(function (res) { var _a; return (_a = res.data) !== null && _a !== void 0 ? _a : 0; })
            .catch(function (error) { return 0; });
        var getCriticalfollowUpCount = leadDi.leads
            .getCriticalfollowUpCount()
            .catch(function (error) { return ({ totalCount: 0 }); });
        Promise.all([
            getFollowUpAgingRMs,
            getCriticalPriorityAging,
            getRemappingNotificationList,
            getCriticalfollowUpCount,
            getPipelineAgingLeadCount,
        ])
            .then(function (_a) {
            var _b = __read(_a, 5), followUpAging = _b[0], criticalPriorityAging = _b[1], getRemappingNotificationList = _b[2], getCriticalfollowUpCount = _b[3], getPipelineAgingLeadCount = _b[4];
            setFolloupAgeingData(followUpAging);
            setCriticalPriorityAgingData(criticalPriorityAging);
            setRemappingCount(getRemappingNotificationList.data);
            setCriticalLeadsCount(getCriticalfollowUpCount.totalCount);
            setPipelineAgingLeadCount(getPipelineAgingLeadCount);
            setNotificationCountExceptExpiry(function (prevCount) {
                return (followUpAging === null || followUpAging === void 0 ? void 0 : followUpAging.length) +
                    (criticalPriorityAging === null || criticalPriorityAging === void 0 ? void 0 : criticalPriorityAging.totalItems) +
                    getPipelineAgingLeadCount +
                    getCriticalfollowUpCount.totalCount;
            });
            getExpiringLeads();
            setNotificationLoader(false);
        })
            .catch(function (error) {
            getExpiringLeads();
            setNotificationLoader(false);
            console.error("One or more API calls failed:", error);
        });
    };
    //functions related to profile
    var getOnDeskInformation = function () {
        var deskResp = null;
        profileDI.profile
            .getONDeskDetails()
            .then(function (onDeskReponse) {
            setDesk(onDeskReponse);
        })
            .catch(function (err) { });
        return deskResp;
    };
    var getProfilImage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var profileImage_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, profileDI.profile.getProfileImage()];
                case 1:
                    profileImage_1 = _a.sent();
                    if (profileImage_1) {
                        setFile(getImageString(profileImage_1));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var verifyOTP = function (OTP) {
        setShowLoader(true);
        var payload = {
            otpId: maskedUserData.otpId,
            otp: OTP,
        };
        loginDI.login
            .validateChangePassword(payload)
            .then(function (resp) {
            if (resp.data) {
                loginDI.login.changeCurrentLoginComponent({
                    currentComponent: ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS,
                    extraConfig: {
                        OTPDetails: {
                            otpId: maskedUserData.otpId,
                            otp: OTP,
                        },
                    },
                });
                setModalChild(EModalChild.RESET_PASSWORD);
            }
            setShowLoader(false);
        })
            .catch(function (error) {
            if (typeof error.getErrorData() === "object" &&
                error.getErrorData().IsOtpBlocked) {
                setError({
                    isShowError: true,
                    errorMessage: (React.createElement("div", { className: "d-flex align-items-center gap-2 txt_bloodRed DMSanN_14_400" },
                        React.createElement("i", { className: "edel-icon-validation" }),
                        error.getMessage())),
                    isShowErrorInHeader: true,
                });
                setResendOTPDuration({
                    minutes: error.getErrorData()
                        .MaxRequestTime,
                    seconds: 0,
                });
            }
            else {
                setError({
                    isShowError: true,
                    errorMessage: (React.createElement("div", { className: "d-flex align-items-center gap-2 txt_bloodRed DMSanN_14_400" },
                        React.createElement("i", { className: "edel-icon-validation" }),
                        error.getMessage())),
                });
            }
            setShowLoader(false);
        });
    };
    var handleChangePasswordSendOTP = function () {
        setShowLoader(true);
        var payload = {
            currPassword: currentPassword,
            userName: profileData === null || profileData === void 0 ? void 0 : profileData.empcodetxt,
        };
        loginDI.login
            .changePassword(payload)
            .then(function (resp) {
            if (!resp.data.email && !resp.data.mobile && !resp.data.otpId) {
                setError({
                    isShowError: true,
                    errorMessage: (React.createElement("div", { className: "d-flex align-items-center gap-2 txt_bloodRed DMSanN_14_400" },
                        React.createElement("i", { className: "edel-icon-validation" }),
                        resp.data.message)),
                });
            }
            else {
                setMaskedUserData(resp.data);
                setModalChild(EModalChild.OTP_VALIDATION);
            }
            setShowLoader(false);
        })
            .catch(function (error) {
            setShowLoader(false);
            setError({
                isShowError: true,
                errorMessage: (React.createElement("div", { className: "d-flex align-items-center gap-2 txt_bloodRed DMSanN_14_400" },
                    React.createElement("i", { className: "edel-icon-validation" }),
                    error.getMessage())),
            });
        });
    };
    var logOutUser = function () {
        loginDI.login.changeCurrentLoginComponent({
            currentComponent: ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS,
            extraConfig: {
                currentActiveTab: ERole.Partner,
            },
        });
        props === null || props === void 0 ? void 0 : props.logoutUser();
        setShowProfilePopup(false);
    };
    //useEffects related to profile actions
    useEffect(function () {
        if (onDesk) {
            setDesk(onDesk);
        }
        else {
            getOnDeskInformation();
        }
    }, [onDesk]);
    useEffect(function () {
        if (!profileData)
            profileDI.profile.getProfileDetails();
    }, [profileData]);
    useEffect(function () {
        if (profileImage) {
            setFile(getImageString(profileImage));
        }
        else {
            getProfilImage();
        }
    }, [profileImage]);
    useEffect(function () {
        if (!changePasswordPopup && modalChild === EModalChild.SUCCESS_MESSAGE) {
            logOutUser();
        }
    }, [changePasswordPopup, modalChild]);
    // useEffects related to search actions
    useEffect(function () {
        setClientSearchDataState(ClientSearchData);
        setLoader(false);
        var partnerCategory = localStorage.getItem("partnerCategory");
        if (partnerCategory === "BR") {
            setClientSearchDataState([]);
        }
    }, [ClientSearchData]);
    useEffect(function () {
        function handleClickOutside(event) {
            var _a;
            if (!((_a = searchRef === null || searchRef === void 0 ? void 0 : searchRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                setSearchPopup(false);
                setSearchText("");
                setIsSearchFocused(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [searchRef]);
    // useEffects related to notification actions
    useEffect(function () {
        setTotalNotificationCount(notificationCountExceptExpiry +
            Number(expiringLeads.expiringLeads.totalitems));
    }, [(_a = expiringLeads.expiringLeads) === null || _a === void 0 ? void 0 : _a.totalitems, notificationCountExceptExpiry]);
    useEffect(function () {
        getAllNotifications();
    }, []);
    useEffect(function () {
        checkIfMFIsAccessible()
            .then(function (res) {
            setIsMFAccessible(res);
        })
            .catch(function () {
            setIsMFAccessible(false);
        });
    }, []);
    var generateChangePasswordComponent = function () {
        switch (modalChild) {
            case EModalChild.CURRENT_PASSWORD:
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "d-flex justify-content-center mt-4 DMSanN_16_400" }, "Please enter your current password"),
                    React.createElement("div", { className: "d-flex justify-content-center mt-4" },
                        React.createElement(LoginCommonInputButton, { inputValue: currentPassword, setInputValueCallback: function (value) {
                                setCurrentPassword(value);
                                setError({
                                    isShowError: false,
                                    errorMessage: "",
                                });
                            }, inputPlaceholder: "Enter your current password", buttonText: "Send OTP to Authenticate", buttonOnClick: handleChangePasswordSendOTP, buttonDisable: currentPassword.length === 0 || showLoader, errorConfig: error, isShowInputLoader: showLoader, enableClickOnEnter: true, enablePasswordMasking: true }))));
            case EModalChild.OTP_VALIDATION:
                return (React.createElement(OTPValidation, { userData: maskedUserData, verifyOTPCallback: verifyOTP, resendOTPCallback: handleChangePasswordSendOTP, error: {
                        isShowError: error.isShowError,
                        errorMessage: error.errorMessage,
                    }, isShowLoader: showLoader, timerDuration: resendOTPDuration }));
            case EModalChild.RESET_PASSWORD:
                return (React.createElement("div", { className: "d-flex flex-column gap-4 align-items-center pd-20" },
                    React.createElement("div", { className: "DMSans_16_500 txt_blackOne1" }, "Please Enter your new password below"),
                    React.createElement(ResetPassword, { partnerCode: profileData.empcodetxt, showBackToLogin: false, showHeader: false, isChangePassword: true, changePasswordCallback: function () {
                            setPasswordChangeSuccess(true);
                            setModalChild(EModalChild.SUCCESS_MESSAGE);
                        } })));
            case EModalChild.SUCCESS_MESSAGE:
                return React.createElement(ChangePasswordSuccess, { buttonCallBack: logOutUser });
        }
    };
    useEffect(function () {
        if (previousBookmarksCountRef.current &&
            bookmarksCount !== previousBookmarksCountRef.current) {
            setShowBookmarksRippleEffect(true);
            var timeoutId_1 = setTimeout(function () {
                setShowBookmarksRippleEffect(false);
                clearTimeout(timeoutId_1);
            }, 2000);
        }
        return function () {
            previousBookmarksCountRef.current = bookmarksCount;
        };
    }, [bookmarksCount]);
    return (React.createElement("div", { className: "primary-transparent-header-container d-flex justify-content-between w-100" },
        React.createElement("div", null,
            React.createElement(HeaderLeftSideComponent, { children: props === null || props === void 0 ? void 0 : props.leftSideComponent })),
        React.createElement("div", { className: "header-sub-action-buttons-container d-flex align-items-center gap-4 pdr-20" },
            React.createElement("div", { className: "form-container d-flex align-items-center" },
                React.createElement(Form, { className: "common-search ".concat(isSearchFocused && "search-focused-common-search", " d-flex align-items-center"), ref: searchRef },
                    React.createElement("div", { className: "search-input-icons-container d-flex align-items-center" },
                        React.createElement("div", null,
                            React.createElement("i", { className: "edel-icon-search1 p-0" })),
                        React.createElement("input", { className: "DMSanN_14_400 txt_blue-tint bg_white ".concat(isSearchFocused && "search-focused"), type: "search", value: searchText, placeholder: loginDI.login.getIsRMPartnerFRM().isFRM
                                ? "Search Client / Partner"
                                : "Search Client", "aria-label": "Search", onChange: handleOnchangeSearch, onFocus: function () { return setIsSearchFocused(true); }, ref: searchInputRef }),
                        isSearchFocused && (React.createElement("span", { className: "edel-icon-close hand_cursor", onClick: function () {
                                setSearchText("");
                                setSearchPopup(false);
                                setSearchText("");
                                searchInputRef.current.focus();
                            } }))),
                    searchPopup && searchText !== "" && (React.createElement("div", { className: "px-0 position-absolute bg_white clientsearch-popup header w-100 d-flex flex-column align-items-start" },
                        React.createElement(ClientSearch, { clientSearchList: clientSearchDataState, searchText: searchText, loader: loader, setCallbackFunction: callBackFunctionClientSearch })))),
                React.createElement("div", { className: "d-flex align-items-center gap-3 " },
                    isMFAccessible && (React.createElement("div", { className: "position-relative" },
                        React.createElement(EdButtonIcon, { id: "bookmarks-icon-header", className: "hand_cursor", btnIcon: "edel-icon-all-bookmarks", btnTyp: "text-only", onClick: function () {
                                navigate("/dashboard/saved-products");
                            } }),
                        bookmarksCount > 0 && (React.createElement("span", { className: "notifications-dot bookmarks__icon__red__dot d-flex ".concat(showBookmarksRippleEffect ? "ripple" : "") })))),
                    React.createElement(GenericPopup, { parentClass: "header-popup-notify", isHeadline: true, containerDom: function () {
                            return document.getElementById("header-notification-icon-wrapper");
                        }, button: React.createElement("div", { className: "notification d-flex hand_cursor", onClick: function () { return setNotifyPopup(!notifyPopup); }, id: "header-notification-icon-wrapper" },
                            React.createElement("i", { className: "edel-icon-notification-bell-2 hand_cursor" }),
                            totolNotificationCount > 0 && (React.createElement("span", { className: "notifications-dot d-flex" }))), children: 
                        // <NotifyPopup
                        //   client360={false}
                        //   expiringLeads={expiringLeads.expiringLeads}
                        //   setNotifyPopup={setNotifyPopup}
                        // />
                        React.createElement(NotificationPopup, { client360: false, pipelineAgingLeadCount: pipelineAgingLeadCount, loader: notificationLoader, criticalPriorityAging: criticalPriorityAging, folloupAgeingData: folloupAgeingData, setNotifyPopup: setNotifyPopup, criticalLeadsCount: criticalLeadsCount, getAllNotifications: function () {
                                getAllNotifications();
                            }, expiringLeads: Number(expiringLeads.expiringLeads.totalitems), remappingCount: remappingCount }), placement: "bottom-end", onClose: function () { return setNotifyPopup(!notifyPopup); } }),
                    React.createElement(GenericPopup, { parentClass: "header-popups", isHeadline: true, containerDom: function () { return document.getElementById("profile-popup-id"); }, button: React.createElement("div", { tabIndex: 0, className: "profile d-flex position-relative", onClick: function () { return setShowProfilePopup(!showProfilePopup); }, id: "profile-popup-id" },
                            React.createElement("div", { className: "user-profile d-flex hand_cursor" }, file ? (React.createElement("img", { alt: "", className: "rounded-circle hand_cursor prof-img-dimension", src: file ? file : null })) : (React.createElement(TextFirstAlphabetAsIcon, { textToExtractWordFrom: (profileData === null || profileData === void 0 ? void 0 : profileData.empName) ? profileData === null || profileData === void 0 ? void 0 : profileData.empName : "", textAndBackgroundColorCollection: iconTextColorForProfileIcon }))),
                            React.createElement("div", { className: "green-dot" },
                                React.createElement("i", { className: "edel-icon-round-circle ".concat(desk !== null && !desk ? "txt_bloodRed" : "txt_green") }))), placement: "bottom-end", children: showProfilePopup && (React.createElement(ProfilePopup, { isOnDesk: onDesk, setDesk: setDesk, desk: desk, setProfilePopup: setShowProfilePopup, client360: false, changePasswordPopup: changePasswordPopup, setChangePasswordPopup: setChangePasswordPopup, setShowDeskPeriodPopup: setShowDeskPeriodPopup, logoutUser: logOutUser })), onClose: function () { return setShowProfilePopup(false); } }))),
            React.createElement("div", { className: passwordChangeSuccess
                    ? "password-success-popup"
                    : "change-pass-poup" }, changePasswordPopup && (React.createElement(EdModal, { show: changePasswordPopup, setShow: setChangePasswordPopup, showFooter: false, modalTitle: "", title: passwordChangeSuccess
                    ? "Password Changed Successfully!"
                    : "Change Password", children: generateChangePasswordComponent(), size: "change-password-modal" })))),
        showDeskPeriodPopup && (React.createElement(EdModal, { title: "Set Off Desk Period", show: showDeskPeriodPopup, size: "modal-dialog-centered", setShow: function () {
                setShowDeskPeriodPopup(!showDeskPeriodPopup);
                setShowProfilePopup(!showProfilePopup);
            }, modalTitle: "desk-period-class", showFooter: false, closeOnOutsideClick: false, children: React.createElement(SetOffDesk, { setShowDeskPeriodPopup: setShowDeskPeriodPopup }) }))));
};
export default TransparentHeader;
export var generatePageHeaderName = function (text, extraClassName) {
    return (React.createElement("div", { className: "DMSan_28_400 txt_white ".concat(extraClassName !== null && extraClassName !== void 0 ? extraClassName : "") }, text));
};
